const scrollToId = (id: string) => {
    const idToScrollTo = document.getElementById(id);
    const viewportPosition = idToScrollTo?.getBoundingClientRect().top || 0;
    const viewportToDocument = window.scrollY;
    const scrollTopPx = viewportPosition + viewportToDocument;

    document.body.scrollTop = scrollTopPx; // Safari
    document.documentElement.scrollTop = scrollTopPx; // Chrome, Firefox, IE and Opera
};

export default scrollToId;
